import {
  IonCol,
  IonContent,
  IonGrid,
  IonImg,
  IonInput,
  IonItem,
  IonLabel,
  IonLoading,
  IonNote,
  IonPage,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonText,
  IonToast,
} from "@ionic/react";
import { useEffect, useState } from "react";
import { signUp } from "../../genericFunctions/signUp";
import { makeGETRequest } from "../../request/rawRequest";
import { paramsSingup } from "../../types/types";
import "../IonColor/color.css";
import TechnoListButton from "../TechnoListButton/TechnoListButton";
import "./Register.css";
import regsiterItems, { registerItem } from "./registerInterface";

interface ContainerProps {
  endpoint: string;
  pathLogo: string;
}

type Eta = {
  name: string;
  _id: string;
};

const eta = async (): Promise<Eta[]> => {
  const res: Eta[] = [];

  await makeGETRequest("/schools").then(async (response) => {
    response.map((r: any) => {
      res.push({
        name: r.name,
        _id: r._id,
      });
    });
  });

  return res;
};

const teachers = async (idEta: string): Promise<string[]> => {
  const res: string[] = [];

  await makeGETRequest("/school/trainers?etablissement=" + idEta).then(
    async (response) => {
      response.map((r: any) => {
        res.push(r.first_name + " " + r.last_name);
      });
    }
  );

  return res;
};

function arraysEqual(a: string[], b: string[]) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;
  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

const Register: React.FC<ContainerProps> = ({ pathLogo }) => {
  const [items, setItems] = useState<registerItem[]>(regsiterItems);
  const [updateItems, setUpdateItems] = useState<boolean>(false);

  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [message, setMessage] = useState<string | undefined>("none");
  const urlParams = new URLSearchParams(window.location.search);

  const [etablissement, setEtablissement] = useState<Eta[]>([]);
  const [profs, setProfs] = useState<string[]>([]);

  const handleRegister = async () => {
    const itemStatut = items.find((i) => i.itemName === "statut");
    const itemEtablissement = items.find((i) => i.itemName === "etablissement");
    const itemFormateur = items.find((i) => i.itemName === "prof");
    const itemClasse = items.find((i) => i.itemName === "classe");

    switch (itemStatut?.value) {
      case "eleve":
        itemClasse!.isValid = true;
        if (itemClasse!.value.length <= 2) {
          itemClasse!.value = "optional";
        }
        break;
      case "enseignant":
        itemFormateur!.value = "not needed";
        itemClasse!.value = "not needed";
        itemFormateur!.isValid = true;
        itemClasse!.isValid = true;
        break;
      case "autre":
        itemEtablissement!.value = "not needed";
        itemFormateur!.value = "not needed";
        itemClasse!.value = "not needed";
        itemEtablissement!.isValid = true;
        itemFormateur!.isValid = true;
        itemClasse!.isValid = true;
        break;

      default:
        itemStatut!.isValid = false;
        break;
    }

    const notValidItems = items.filter((i) => i.isValid === false);

    if (notValidItems.length === 0) {
      const params: paramsSingup = {
        last_name: items.find((i) => i.itemName === "lastname")!.value,
        first_name: items.find((i) => i.itemName === "firstname")!.value,

        email: items.find((i) => i.itemName === "email")!.value,
        phone_number: items.find((i) => i.itemName === "phoneNumber")!.value,
        password: items.find((i) => i.itemName === "password")!.value,

        etablissement: items.find((i) => i.itemName === "etablissement")!.value,
        formateur: items.find((i) => i.itemName === "prof")!.value,

        premium: urlParams.get("premium") ? true : false,
      };
      setShowLoading(true);
      await signUp(params, setMessage, setShowLoading)
        .then(() => {
          setShowLoading(false);
        })
        .catch((error) => {
          setShowLoading(false);
          if (message !== "none") {
            setShowToast(true);
            setMessage(error);
          }
        });
    } else {
      setMessage(
        "Veuillez vérifier le champ suivant :" + notValidItems[0].displayName
      );
      setShowToast(true);
    }
  };

  const handleItemsRegisterVerify = (currentItem: registerItem) => {
    const currentItemValue = currentItem.value;
    if (currentItem.type === "password") {
      const passwordItem = items.find((i) => i.itemName === "password");
      const passwordConfirmationItem = items.find(
        (i) => i.itemName === "passwordConfirmation"
      );

      passwordItem!.isValid =
        passwordItem?.errorRegex?.test(passwordItem.value) ?? false;

      passwordConfirmationItem!.isValid =
        (passwordConfirmationItem?.value === passwordItem?.value &&
          (passwordItem?.value || "").length > 0 &&
          (passwordConfirmationItem?.value || "").length > 0) ??
        false;
    } else if (
      currentItemValue.length > 0 &&
      currentItemValue.match(currentItem.errorRegex ?? "") !== null
    ) {
      currentItem.isValid = true;
    } else {
      currentItem.isValid = false;
    }
  };

  const handleChangeValue = (value: string, index: number) => {
    setItems((old) => [
      ...old.slice(0, index),
      {
        ...old[index],
        value: value,
      },
      ...old.slice(index + 1, old.length),
    ]);
    setUpdateItems(true);
  };

  const handleDismiss = () => {
    setShowToast(false);
    setMessage("");
  };

  useEffect(() => {
    eta().then((res) => {
      const etaItemIndex = items.findIndex(
        (i) => i.itemName === "etablissement"
      )!;
      const etaItem = items.find((i) => i.itemName === "etablissement")!;

      etaItem.values = res.map((e) => ({ label: e.name, value: e.name }));

      setItems((old) => [
        ...old.slice(0, etaItemIndex),
        { ...etaItem },
        ...old.slice(etaItemIndex + 1, old.length),
      ]);

      setEtablissement(res);
    });
  }, []);

  useEffect(() => {
    const selectedEta = items.find((i) => i.itemName === "etablissement")!;

    if (selectedEta.value.length > 0) {
      const currentEtaID = etablissement.find(
        (e) => e.name === selectedEta.value
      )!._id;

      teachers(currentEtaID).then((res) => {
        const filterRes = res.filter((p) => !p.includes("@"));
        if (arraysEqual(filterRes as string[], profs) === false)
          setProfs(filterRes);
      });
    }
  }, [items]);

  useEffect(() => {
    if (updateItems === true) {
      items.map((item) => {
        handleItemsRegisterVerify(item);
      });
      setUpdateItems(false);
    }
  }, [updateItems]);

  useEffect(() => {
    const profsItem = items.find((i) => i.itemName === "prof")!;
    const profsItemIndex = items.findIndex((i) => i.itemName === "prof")!;
    if (!profsItem || !profsItemIndex) return;

    setItems((old) => [
      ...old.slice(0, profsItemIndex),
      { ...profsItem, values: profs.map((p) => ({ label: p, value: p })) },
      ...old.slice(profsItemIndex + 1, old.length),
    ]);
  }, [profs]);

  return (
    <IonPage className="register">
      {/* Displaying error on login */}
      <IonToast
        isOpen={showToast}
        onDidDismiss={() => handleDismiss()}
        message={message}
        position="middle"
        color="danger"
        duration={2000}
      />
      {/* End of dislplaying error on login */}

      {/* Display REGISTER */}
      <IonLoading
        isOpen={showLoading}
        onDidDismiss={() => setShowLoading(false)}
        message={"Chargement..."}
      />
      <IonContent color="primary">
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            <IonCol size-lg="5" size-sm="10">
              <IonRow className="ion-justify-content-center">
                <IonCol size-lg="3" size="6" size-sm="6">
                  {/* <IonImg
                    src={pathLogo}
                    alt="loginImage"
                    className="loginImg"
                  /> */}
                  <IonImg
                    style={{ marginTop: 50 }}
                    src={pathLogo}
                    alt="loginImage"
                    className="loginImg"
                  />
                </IonCol>
              </IonRow>
            </IonCol>
          </IonRow>
          <IonRow className="ion-justify-content-center">
            <IonCol size-lg="5" size-sm="10">
              <IonRow className="ion-justify-content-center">
                <IonText color="black" className="ion-text-center">
                  <h1>Connexion</h1>
                  <h5>Veuillez entrer vos informations</h5>
                </IonText>
              </IonRow>
              {items.map((item, index) => {
                if (
                  !item.isDependant ||
                  (item.dependance &&
                    item.dependance.value.includes(
                      items.find(
                        (i) => i.itemName === item.dependance!.registerItemName
                      )!.value
                    ))
                )
                  if (!item.isSelect) {
                    return (
                      <IonItem
                        color="transparent"
                        key={index}
                        className={item.isValid ? "ion-valid" : "ion-invalid"}
                      >
                        <IonLabel color="black" position="floating">
                          {item.displayName}
                        </IonLabel>
                        <IonInput
                          className="border-bottom"
                          name={item.itemName}
                          type={item.type}
                          value={item.value}
                          onKeyUp={(e) => {
                            handleChangeValue(
                              (e.target as HTMLInputElement).value,
                              index
                            );
                          }}
                          required
                        ></IonInput>
                        <IonNote slot="error">{item.errorMsg}</IonNote>
                      </IonItem>
                    );
                  } else {
                    return (
                      <IonItem
                        color="transparent"
                        key={index}
                        className={item.isValid ? "ion-valid" : "ion-invalid"}
                      >
                        <IonLabel color="black" position="floating">
                          {item.displayName}
                        </IonLabel>
                        <IonSelect
                          aria-required="true"
                          interface="popover"
                          onIonChange={(e) => {
                            handleChangeValue(e.detail.value, index);
                          }}
                        >
                          {item.values?.map((v, i) => {
                            return (
                              <IonSelectOption key={i} value={v.value}>
                                {v.label}
                              </IonSelectOption>
                            );
                          })}
                        </IonSelect>
                        <IonNote slot="error">{item.errorMsg}</IonNote>
                      </IonItem>
                    );
                  }
              })}

              <IonRow>
                <IonItem color="transparent"></IonItem>
              </IonRow>

              <IonRow className="ion-justify-content-center">
                <IonCol size="12" size-sm="12" size-lg="6">
                  <IonItem color="transparent">
                    <button
                      color="transparent"
                      type="submit"
                      className="btn bold"
                      onClick={() => handleRegister()}
                    >
                      Crée ton compte
                    </button>
                  </IonItem>
                </IonCol>
                <IonCol size="12" size-sm="12" size-lg="6">
                  <IonItem color="transparent">
                    <button
                      className="btn btn-shade"
                      onClick={() => {
                        window.location.href =
                          "home?" +
                          (new URLSearchParams(window.location.search).get(
                            "premium"
                          ) !== null
                            ? "premium=true"
                            : "");
                      }}
                    >
                      Déjà un compte
                    </button>
                  </IonItem>
                </IonCol>
              </IonRow>
              <TechnoListButton />
              {/* </form> */}
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default Register;
